import LivestreamPiP from '@/components/daytrading/components/LivestreamPiP';
import DirectStreamPiP from '@/components/daytrading/components/DirectStreamPiP';
import type { DayTradingStreamInfo } from '@/hooks/useDayTradingWebSocket';
import { getStreamSourceKey } from '@/utils/stream-info';

interface StreamPiPProps {
  streamInfo: DayTradingStreamInfo;
  minimized: boolean;
  onMinimize: () => void;
}

/**
 * Renders the appropriate draggable PiP for the current stream mode.
 * GOOGLE_MEET and NONE render nothing — those modes have no embedded player.
 */
export default function StreamPiP({ streamInfo, minimized, onMinimize }: StreamPiPProps) {
  const sourceKey = getStreamSourceKey(streamInfo);
  if (sourceKey === '') return null;

  if (streamInfo.mode === 'YOUTUBE') {
    return (
      <LivestreamPiP
        key={sourceKey}
        youtubeUrl={streamInfo.youtubeURL}
        minimized={minimized}
        onMinimize={onMinimize}
      />
    );
  }
  if (streamInfo.mode === 'DIRECT') {
    return (
      <DirectStreamPiP
        key={sourceKey}
        viewerUrl={streamInfo.directStreamViewerURL}
        minimized={minimized}
        onMinimize={onMinimize}
      />
    );
  }
  return null;
}
